import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store'
import Dashboard from '@/components/Dashboard'
import LandingPage from '@/components/LandingPage'
import auth from '@/auth.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
        title: 'KNOWMAK - Knowledge in the Making in the European Society'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'KNOWMAK Dashboard'
      },
      beforeEnter: async (to, from, next) => {
        // Authentication check

        // TODO PEG: re-activate auth check
        console.log(auth)
        // await auth.checkAuth(to.path)
        next()
      }
    }
  ],
  mode: 'history'
})

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored
  document.title = to.meta.title
  next()
}

router.beforeEach(waitForStorageToBeReady)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js